import { render, staticRenderFns } from "./TopbarIndeegoSettings.vue?vue&type=template&id=4c10a261&scoped=true&"
import script from "./TopbarIndeegoSettings.vue?vue&type=script&lang=js&"
export * from "./TopbarIndeegoSettings.vue?vue&type=script&lang=js&"
import style0 from "./TopbarIndeegoSettings.vue?vue&type=style&index=0&id=4c10a261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10a261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow,VSpacer})
